import { app } from '../../../../bootstrap/core';
import { authorizationReceivingState } from './authorizationReceiving.state';
import { authorizationReceivingComponent } from './authorizationReceiving.component';

app.config(authorizationReceivingState);
app.component(authorizationReceivingComponent.name, authorizationReceivingComponent);
